









import { Vue, Component, Prop } from 'vue-property-decorator'
import PropertyCard from '@/properties/PropertyCard.vue'
import { Property } from '../properties/types'
import { propertiesStore } from "@/properties/store";

@Component({
  components: { PropertyCard }
})
export default class MyPropertiesTab extends Vue {

  properties: Property[] = [];
  state: "idle" | "busy" | "done" = "idle";

  async created() {
    this.state = 'busy';
    await propertiesStore.loadProperties();
    this.properties = propertiesStore.state.items;
    this.state = 'idle';
  }

}
